import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import { useTranslation } from "react-i18next";
const TermsAndConditions = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("TermsSeoTitle"),
      description: t("TermsSeoDesc"),
      keywords: t("TermsSeoKeywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
    });
  }, [setSeo, t]);

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-12 mb-5 text-center">
          <h4 className="fw-light">{t("TermsAndConditionsTitle")}</h4>
        </div>

        <p>
          {t("TermsAndConditionsText1")}
          <br />
          <br />
          {t("TermsAndConditionsText2")}
          <br />
          <br />
          {t("TermsAndConditionsText3")}
          <br />
          <br />
          {t("TermsAndConditionsText4")}
          <br />
          <br />
        </p>
        <h4>{t("TermsSection1Title")}</h4>
        <p>{t("TermsSection1Text")}</p>
        <h4>{t("TermsSection2Title")}</h4>
        <p>{t("TermsSection2Text")}</p>
        <h4>{t("TermsSection3Title")}</h4>
        <p>{t("TermsSection3Text")}</p>

        <h4>{t("TermsSection4Title")}</h4>
        <p>{t("TermsSection4Text")}</p>

        <h4>{t("TermsSection5Title")}</h4>
        <p>{t("TermsSection5Text")}</p>
        <h4>{t("TermsSection6Title")}</h4>
        <p>{t("TermsSection6Text")}</p>
        <h4>{t("TermsSection7Title")}</h4>
        <p>
          {t("TermsSection7Text")}
          <br />
          <br />
        </p>
        <h4>{t("TermsSection8Title")}</h4>
        <p>
          {t("TermsSection8Text")}
          <br />
          <br />
        </p>
        <h4>{t("TermsSection9Title")}</h4>
        <p>{t("TermsSection9Text")}</p>
        <h4>{t("TermsSection10Title")}</h4>
        <p>{t("TermsSection10Text")}</p>
        <h4>{t("TermsSection11Title")}</h4>
        <p>{t("TermsSection11Text")}</p>
        <h4>{t("TermsSection12Title")}</h4>
        <p>{t("TermsSection12Text")}</p>
        <h4>{t("TermsSection13Title")}</h4>
        <p>
          {t("TermsSection13Text")}
          <br />
          <br />
        </p>
        <h4>{t("TermsSection14Title")}</h4>
        <p>
          {t("TermsSection14Text")}
          <br />
          <br />
        </p>
        <h4>{t("TermsSection15Title")}</h4>
        <p>{t("TermsSection15Text")}</p>
        <h4>{t("TermsSection16Title")}</h4>
        <p>
          {t("TermsSection16Text")}
          <br />
          <br />
        </p>
        <h4>{t("TermsSection17Title")}</h4>
        <p>{t("TermsSection17Text")}</p>
        <h4>{t("TermsSection18Title")}</h4>
        <p>{t("TermsSection18Text")}</p>
        <h4>{t("TermsSection19Title")}</h4>
        <p>{t("TermsSection19Text")}</p>
        <h4>{t("TermsSection20Title")}</h4>
        <p>{t("TermsSection20Text")}</p>
        <h4>{t("TermsSection21Title")}</h4>
        <p>{t("TermsSection21Text")}</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
